import React from 'react';

interface IStyledSubtitleProps {
  text: string;
  className?: string;
}

const CHINESE_CHAR_REGEXP = /[\u3400-\u9FFF\uF900-\uFAFF]/;
const SUBTITLE_SEGMENT_REGEXP = /[\u3400-\u9FFF\uF900-\uFAFF]+|[A-Za-z0-9\s]+|./g;

const getSegmentType = (segment: string) => (CHINESE_CHAR_REGEXP.test(segment) ? 'zh' : 'en');

const StyledSubtitle: React.FC<IStyledSubtitleProps> = ({ text, className = 'dbi-worldwide-subtitle' }) => {
  const segments = text.match(SUBTITLE_SEGMENT_REGEXP) || [text];

  return (
    <div className={className}>
      {segments.map((segment, index) => (
        <span
          key={`${segment}-${index}`}
          className={`dbi-worldwide-subtitle__segment dbi-worldwide-subtitle__segment--${getSegmentType(segment)}`}
        >
          {segment}
        </span>
      ))}
    </div>
  );
};

export default StyledSubtitle;
